/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var teladoc_protobuf_common_user_communication_comms_pb = require('../../../../../teladoc/protobuf/common/user/communication/comms_pb.js');
var teladoc_protobuf_common_user_identity_userId_pb = require('../../../../../teladoc/protobuf/common/user/identity/userId_pb.js');
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.ChannelState', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.CommsPreference', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.FeaturePreference', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.FeatureState', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.OptOutRecord', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.State', null, global);
goog.exportSymbol('proto.com.teladoc.protobuf.common.user.communication.State.Values', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.repeatedFields_, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.displayName = 'proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: (f = msg.getUserId()) && teladoc_protobuf_common_user_identity_userId_pb.UserId.toObject(includeInstance, f),
    phoneNumberGroup: jspb.Message.getFieldWithDefault(msg, 2, 0),
    channelStatesList: jspb.Message.toObjectList(msg.getChannelStatesList(),
    proto.com.teladoc.protobuf.common.user.communication.ChannelState.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference;
  return proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new teladoc_protobuf_common_user_identity_userId_pb.UserId;
      reader.readMessage(value,teladoc_protobuf_common_user_identity_userId_pb.UserId.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values} */ (reader.readEnum());
      msg.setPhoneNumberGroup(value);
      break;
    case 3:
      var value = new proto.com.teladoc.protobuf.common.user.communication.ChannelState;
      reader.readMessage(value,proto.com.teladoc.protobuf.common.user.communication.ChannelState.deserializeBinaryFromReader);
      msg.addChannelStates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      teladoc_protobuf_common_user_identity_userId_pb.UserId.serializeBinaryToWriter
    );
  }
  f = message.getPhoneNumberGroup();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getChannelStatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.com.teladoc.protobuf.common.user.communication.ChannelState.serializeBinaryToWriter
    );
  }
};


/**
 * optional com.teladoc.protobuf.common.user.identity.UserId user_id = 1;
 * @return {?proto.com.teladoc.protobuf.common.user.identity.UserId}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.prototype.getUserId = function() {
  return /** @type{?proto.com.teladoc.protobuf.common.user.identity.UserId} */ (
    jspb.Message.getWrapperField(this, teladoc_protobuf_common_user_identity_userId_pb.UserId, 1));
};


/** @param {?proto.com.teladoc.protobuf.common.user.identity.UserId|undefined} value */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.prototype.setUserId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.prototype.clearUserId = function() {
  this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PhoneNumberGroup.Values phone_number_group = 2;
 * @return {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.prototype.getPhoneNumberGroup = function() {
  return /** @type {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values} value */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.prototype.setPhoneNumberGroup = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated ChannelState channel_states = 3;
 * @return {!Array<!proto.com.teladoc.protobuf.common.user.communication.ChannelState>}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.prototype.getChannelStatesList = function() {
  return /** @type{!Array<!proto.com.teladoc.protobuf.common.user.communication.ChannelState>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.teladoc.protobuf.common.user.communication.ChannelState, 3));
};


/** @param {!Array<!proto.com.teladoc.protobuf.common.user.communication.ChannelState>} value */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.prototype.setChannelStatesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.com.teladoc.protobuf.common.user.communication.ChannelState=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.teladoc.protobuf.common.user.communication.ChannelState}
 */
proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.prototype.addChannelStates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.com.teladoc.protobuf.common.user.communication.ChannelState, opt_index);
};


proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroupPreference.prototype.clearChannelStatesList = function() {
  this.setChannelStatesList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.FeaturePreference, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.displayName = 'proto.com.teladoc.protobuf.common.user.communication.FeaturePreference';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.FeaturePreference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: (f = msg.getUserId()) && teladoc_protobuf_common_user_identity_userId_pb.UserId.toObject(includeInstance, f),
    featureState: (f = msg.getFeatureState()) && proto.com.teladoc.protobuf.common.user.communication.FeatureState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.FeaturePreference}
 */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.FeaturePreference;
  return proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.FeaturePreference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.FeaturePreference}
 */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new teladoc_protobuf_common_user_identity_userId_pb.UserId;
      reader.readMessage(value,teladoc_protobuf_common_user_identity_userId_pb.UserId.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.com.teladoc.protobuf.common.user.communication.FeatureState;
      reader.readMessage(value,proto.com.teladoc.protobuf.common.user.communication.FeatureState.deserializeBinaryFromReader);
      msg.setFeatureState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.FeaturePreference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      teladoc_protobuf_common_user_identity_userId_pb.UserId.serializeBinaryToWriter
    );
  }
  f = message.getFeatureState();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.teladoc.protobuf.common.user.communication.FeatureState.serializeBinaryToWriter
    );
  }
};


/**
 * optional com.teladoc.protobuf.common.user.identity.UserId user_id = 1;
 * @return {?proto.com.teladoc.protobuf.common.user.identity.UserId}
 */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.prototype.getUserId = function() {
  return /** @type{?proto.com.teladoc.protobuf.common.user.identity.UserId} */ (
    jspb.Message.getWrapperField(this, teladoc_protobuf_common_user_identity_userId_pb.UserId, 1));
};


/** @param {?proto.com.teladoc.protobuf.common.user.identity.UserId|undefined} value */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.prototype.setUserId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.prototype.clearUserId = function() {
  this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FeatureState feature_state = 2;
 * @return {?proto.com.teladoc.protobuf.common.user.communication.FeatureState}
 */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.prototype.getFeatureState = function() {
  return /** @type{?proto.com.teladoc.protobuf.common.user.communication.FeatureState} */ (
    jspb.Message.getWrapperField(this, proto.com.teladoc.protobuf.common.user.communication.FeatureState, 2));
};


/** @param {?proto.com.teladoc.protobuf.common.user.communication.FeatureState|undefined} value */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.prototype.setFeatureState = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.prototype.clearFeatureState = function() {
  this.setFeatureState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.com.teladoc.protobuf.common.user.communication.FeaturePreference.prototype.hasFeatureState = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.teladoc.protobuf.common.user.communication.CommsPreference.repeatedFields_, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.CommsPreference, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.CommsPreference.displayName = 'proto.com.teladoc.protobuf.common.user.communication.CommsPreference';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.CommsPreference.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.CommsPreference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: (f = msg.getUserId()) && teladoc_protobuf_common_user_identity_userId_pb.UserId.toObject(includeInstance, f),
    phoneNumberGroup: jspb.Message.getFieldWithDefault(msg, 2, 0),
    channelStatesList: jspb.Message.toObjectList(msg.getChannelStatesList(),
    proto.com.teladoc.protobuf.common.user.communication.ChannelState.toObject, includeInstance),
    featureStatesList: jspb.Message.toObjectList(msg.getFeatureStatesList(),
    proto.com.teladoc.protobuf.common.user.communication.FeatureState.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.CommsPreference}
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.CommsPreference;
  return proto.com.teladoc.protobuf.common.user.communication.CommsPreference.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.CommsPreference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.CommsPreference}
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new teladoc_protobuf_common_user_identity_userId_pb.UserId;
      reader.readMessage(value,teladoc_protobuf_common_user_identity_userId_pb.UserId.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values} */ (reader.readEnum());
      msg.setPhoneNumberGroup(value);
      break;
    case 3:
      var value = new proto.com.teladoc.protobuf.common.user.communication.ChannelState;
      reader.readMessage(value,proto.com.teladoc.protobuf.common.user.communication.ChannelState.deserializeBinaryFromReader);
      msg.addChannelStates(value);
      break;
    case 4:
      var value = new proto.com.teladoc.protobuf.common.user.communication.FeatureState;
      reader.readMessage(value,proto.com.teladoc.protobuf.common.user.communication.FeatureState.deserializeBinaryFromReader);
      msg.addFeatureStates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.CommsPreference.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.CommsPreference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      teladoc_protobuf_common_user_identity_userId_pb.UserId.serializeBinaryToWriter
    );
  }
  f = message.getPhoneNumberGroup();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getChannelStatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.com.teladoc.protobuf.common.user.communication.ChannelState.serializeBinaryToWriter
    );
  }
  f = message.getFeatureStatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.com.teladoc.protobuf.common.user.communication.FeatureState.serializeBinaryToWriter
    );
  }
};


/**
 * optional com.teladoc.protobuf.common.user.identity.UserId user_id = 1;
 * @return {?proto.com.teladoc.protobuf.common.user.identity.UserId}
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.getUserId = function() {
  return /** @type{?proto.com.teladoc.protobuf.common.user.identity.UserId} */ (
    jspb.Message.getWrapperField(this, teladoc_protobuf_common_user_identity_userId_pb.UserId, 1));
};


/** @param {?proto.com.teladoc.protobuf.common.user.identity.UserId|undefined} value */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.setUserId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.clearUserId = function() {
  this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PhoneNumberGroup.Values phone_number_group = 2;
 * @return {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values}
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.getPhoneNumberGroup = function() {
  return /** @type {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values} value */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.setPhoneNumberGroup = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated ChannelState channel_states = 3;
 * @return {!Array<!proto.com.teladoc.protobuf.common.user.communication.ChannelState>}
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.getChannelStatesList = function() {
  return /** @type{!Array<!proto.com.teladoc.protobuf.common.user.communication.ChannelState>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.teladoc.protobuf.common.user.communication.ChannelState, 3));
};


/** @param {!Array<!proto.com.teladoc.protobuf.common.user.communication.ChannelState>} value */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.setChannelStatesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.com.teladoc.protobuf.common.user.communication.ChannelState=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.teladoc.protobuf.common.user.communication.ChannelState}
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.addChannelStates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.com.teladoc.protobuf.common.user.communication.ChannelState, opt_index);
};


proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.clearChannelStatesList = function() {
  this.setChannelStatesList([]);
};


/**
 * repeated FeatureState feature_states = 4;
 * @return {!Array<!proto.com.teladoc.protobuf.common.user.communication.FeatureState>}
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.getFeatureStatesList = function() {
  return /** @type{!Array<!proto.com.teladoc.protobuf.common.user.communication.FeatureState>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.teladoc.protobuf.common.user.communication.FeatureState, 4));
};


/** @param {!Array<!proto.com.teladoc.protobuf.common.user.communication.FeatureState>} value */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.setFeatureStatesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.com.teladoc.protobuf.common.user.communication.FeatureState=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.teladoc.protobuf.common.user.communication.FeatureState}
 */
proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.addFeatureStates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.com.teladoc.protobuf.common.user.communication.FeatureState, opt_index);
};


proto.com.teladoc.protobuf.common.user.communication.CommsPreference.prototype.clearFeatureStatesList = function() {
  this.setFeatureStatesList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.OptOutRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.displayName = 'proto.com.teladoc.protobuf.common.user.communication.OptOutRecord';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.OptOutRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: (f = msg.getUserId()) && teladoc_protobuf_common_user_identity_userId_pb.UserId.toObject(includeInstance, f),
    phoneNumberGroup: jspb.Message.getFieldWithDefault(msg, 2, 0),
    channelState: (f = msg.getChannelState()) && proto.com.teladoc.protobuf.common.user.communication.ChannelState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.OptOutRecord}
 */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.OptOutRecord;
  return proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.OptOutRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.OptOutRecord}
 */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new teladoc_protobuf_common_user_identity_userId_pb.UserId;
      reader.readMessage(value,teladoc_protobuf_common_user_identity_userId_pb.UserId.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values} */ (reader.readEnum());
      msg.setPhoneNumberGroup(value);
      break;
    case 3:
      var value = new proto.com.teladoc.protobuf.common.user.communication.ChannelState;
      reader.readMessage(value,proto.com.teladoc.protobuf.common.user.communication.ChannelState.deserializeBinaryFromReader);
      msg.setChannelState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.OptOutRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      teladoc_protobuf_common_user_identity_userId_pb.UserId.serializeBinaryToWriter
    );
  }
  f = message.getPhoneNumberGroup();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getChannelState();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.com.teladoc.protobuf.common.user.communication.ChannelState.serializeBinaryToWriter
    );
  }
};


/**
 * optional com.teladoc.protobuf.common.user.identity.UserId user_id = 1;
 * @return {?proto.com.teladoc.protobuf.common.user.identity.UserId}
 */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.prototype.getUserId = function() {
  return /** @type{?proto.com.teladoc.protobuf.common.user.identity.UserId} */ (
    jspb.Message.getWrapperField(this, teladoc_protobuf_common_user_identity_userId_pb.UserId, 1));
};


/** @param {?proto.com.teladoc.protobuf.common.user.identity.UserId|undefined} value */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.prototype.setUserId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.prototype.clearUserId = function() {
  this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PhoneNumberGroup.Values phone_number_group = 2;
 * @return {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values}
 */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.prototype.getPhoneNumberGroup = function() {
  return /** @type {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.com.teladoc.protobuf.common.user.communication.PhoneNumberGroup.Values} value */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.prototype.setPhoneNumberGroup = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ChannelState channel_state = 3;
 * @return {?proto.com.teladoc.protobuf.common.user.communication.ChannelState}
 */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.prototype.getChannelState = function() {
  return /** @type{?proto.com.teladoc.protobuf.common.user.communication.ChannelState} */ (
    jspb.Message.getWrapperField(this, proto.com.teladoc.protobuf.common.user.communication.ChannelState, 3));
};


/** @param {?proto.com.teladoc.protobuf.common.user.communication.ChannelState|undefined} value */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.prototype.setChannelState = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.prototype.clearChannelState = function() {
  this.setChannelState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.com.teladoc.protobuf.common.user.communication.OptOutRecord.prototype.hasChannelState = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.ChannelState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.ChannelState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.ChannelState.displayName = 'proto.com.teladoc.protobuf.common.user.communication.ChannelState';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.ChannelState.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.ChannelState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.ChannelState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.ChannelState.toObject = function(includeInstance, msg) {
  var f, obj = {
    channel: jspb.Message.getFieldWithDefault(msg, 1, 0),
    state: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.ChannelState}
 */
proto.com.teladoc.protobuf.common.user.communication.ChannelState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.ChannelState;
  return proto.com.teladoc.protobuf.common.user.communication.ChannelState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.ChannelState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.ChannelState}
 */
proto.com.teladoc.protobuf.common.user.communication.ChannelState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.teladoc.protobuf.common.user.communication.Channel.Values} */ (reader.readEnum());
      msg.setChannel(value);
      break;
    case 2:
      var value = /** @type {!proto.com.teladoc.protobuf.common.user.communication.State.Values} */ (reader.readEnum());
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.ChannelState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.ChannelState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.ChannelState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.ChannelState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannel();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional Channel.Values channel = 1;
 * @return {!proto.com.teladoc.protobuf.common.user.communication.Channel.Values}
 */
proto.com.teladoc.protobuf.common.user.communication.ChannelState.prototype.getChannel = function() {
  return /** @type {!proto.com.teladoc.protobuf.common.user.communication.Channel.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.com.teladoc.protobuf.common.user.communication.Channel.Values} value */
proto.com.teladoc.protobuf.common.user.communication.ChannelState.prototype.setChannel = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional State.Values state = 2;
 * @return {!proto.com.teladoc.protobuf.common.user.communication.State.Values}
 */
proto.com.teladoc.protobuf.common.user.communication.ChannelState.prototype.getState = function() {
  return /** @type {!proto.com.teladoc.protobuf.common.user.communication.State.Values} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.com.teladoc.protobuf.common.user.communication.State.Values} value */
proto.com.teladoc.protobuf.common.user.communication.ChannelState.prototype.setState = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.FeatureState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.FeatureState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.FeatureState.displayName = 'proto.com.teladoc.protobuf.common.user.communication.FeatureState';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.FeatureState.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.FeatureState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.FeatureState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.FeatureState.toObject = function(includeInstance, msg) {
  var f, obj = {
    feature: jspb.Message.getFieldWithDefault(msg, 1, 0),
    state: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.FeatureState}
 */
proto.com.teladoc.protobuf.common.user.communication.FeatureState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.FeatureState;
  return proto.com.teladoc.protobuf.common.user.communication.FeatureState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.FeatureState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.FeatureState}
 */
proto.com.teladoc.protobuf.common.user.communication.FeatureState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.teladoc.protobuf.common.user.communication.Feature.Values} */ (reader.readEnum());
      msg.setFeature(value);
      break;
    case 2:
      var value = /** @type {!proto.com.teladoc.protobuf.common.user.communication.State.Values} */ (reader.readEnum());
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.FeatureState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.FeatureState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.FeatureState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.FeatureState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFeature();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional Feature.Values feature = 1;
 * @return {!proto.com.teladoc.protobuf.common.user.communication.Feature.Values}
 */
proto.com.teladoc.protobuf.common.user.communication.FeatureState.prototype.getFeature = function() {
  return /** @type {!proto.com.teladoc.protobuf.common.user.communication.Feature.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.com.teladoc.protobuf.common.user.communication.Feature.Values} value */
proto.com.teladoc.protobuf.common.user.communication.FeatureState.prototype.setFeature = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional State.Values state = 2;
 * @return {!proto.com.teladoc.protobuf.common.user.communication.State.Values}
 */
proto.com.teladoc.protobuf.common.user.communication.FeatureState.prototype.getState = function() {
  return /** @type {!proto.com.teladoc.protobuf.common.user.communication.State.Values} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.com.teladoc.protobuf.common.user.communication.State.Values} value */
proto.com.teladoc.protobuf.common.user.communication.FeatureState.prototype.setState = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.teladoc.protobuf.common.user.communication.State = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.teladoc.protobuf.common.user.communication.State, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.com.teladoc.protobuf.common.user.communication.State.displayName = 'proto.com.teladoc.protobuf.common.user.communication.State';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.teladoc.protobuf.common.user.communication.State.prototype.toObject = function(opt_includeInstance) {
  return proto.com.teladoc.protobuf.common.user.communication.State.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.teladoc.protobuf.common.user.communication.State} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.State.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.State}
 */
proto.com.teladoc.protobuf.common.user.communication.State.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.teladoc.protobuf.common.user.communication.State;
  return proto.com.teladoc.protobuf.common.user.communication.State.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.State} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.teladoc.protobuf.common.user.communication.State}
 */
proto.com.teladoc.protobuf.common.user.communication.State.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.teladoc.protobuf.common.user.communication.State.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.teladoc.protobuf.common.user.communication.State.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.teladoc.protobuf.common.user.communication.State} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.teladoc.protobuf.common.user.communication.State.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.teladoc.protobuf.common.user.communication.State.Values = {
  INVALID: 0,
  ON: 1,
  OFF: 2
};

goog.object.extend(exports, proto.com.teladoc.protobuf.common.user.communication);
